import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { graphql, StaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'


class ContactCreative extends React.Component {


  render() {

    const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #000;
            padding: 100px 0;
        `

    const IconRow = styled(Row)`
            margin-top: 150px;
        `

    const IconCol = styled(Col)`
            @media (max-width: 500px) {
              margin-bottom: 140px;
            }
        `

    const IconContainer = styled.div`
            width: 150px;
            height: 150px;
            margin: auto;
            padding: 35px;
            text-align: center;
            position: relative;
            bottom: 75px;
            background-color: #c1eb18;
            border-radius: 150px;
            transition: .5s;
        `

    const InfoPart = styled.div`
            min-height: 250px;
            background-color: #111;
            border: 2px solid #444;
            &:hover ${IconContainer} {
              background-color: #65ff00;
            }
        `

    const InfoTitle = styled.h3`
            font-size: 35px;
            color: #fff;
            font-family: Teko;
            text-align: center;
        `

    const Info = styled.div`
            position: relative;
            bottom: 30px;
        `

    const InfoLinkContainer = styled.div`
            text-align: center;
        `

    const InfoLink = styled.a`
            color: #c1eb18;
            transition: .5s;
            &:hover {
              color: #fff;
              text-decoration: none;
            }
        `

    const Text = styled.p`
          font-size: 17px;          
          font-weight: 300;
          color: #ffffff;
        `
    const Span = styled.span`
          font-size: 17px;          
          font-weight: 300;
          color: #ffffff;
        `

    return (
      <Section id="contact">
        <Container>
          <IconRow>
            <IconCol md={4}>

              <InfoPart>
                <IconContainer>
                  <GatsbyImage image={this.props.image1} alt="Contacto VASCO Solutions" />
                </IconContainer>
                <Info>
                  <InfoTitle>
                    Formulario de contacto
                  </InfoTitle>
                  <InfoLinkContainer>
                    <Text>
                      Estamos listos para despejar tus dudas con nuestro personal de ventas.
                    </Text>
                    <InfoLink href="https://vascosolutions.com/zc/contact.php">
                      Contactar a Ventas
                    </InfoLink> <Span>o</Span>
                    <InfoLink href="https://api.whatsapp.com/send?phone=573102767675" rel="nofollow" target="_blank">
                      &nbsp;WhatsApp
                    </InfoLink>
                  </InfoLinkContainer>
                </Info>
              </InfoPart>

            </IconCol>
            <IconCol md={4}>

              <InfoPart>
                <IconContainer>
                  <GatsbyImage image={this.props.image2} alt="Preguntas Frecuentes" />
                </IconContainer>
                <Info>
                  <InfoTitle>
                    Preguntas Frecuentes
                  </InfoTitle>
                  <InfoLinkContainer>
                    <Text>
                      Consulte Nuestra Base de Conocimientos antes de abrir un ticket.
                    </Text>
                    <InfoLink href="https://vascosolutions.com/zc/index.php/knowledgebase">
                      Consulte nuestra Base
                    </InfoLink>
                  </InfoLinkContainer>
                </Info>
              </InfoPart>

            </IconCol>
            <IconCol md={4}>

              <InfoPart>
                <IconContainer>
                  <GatsbyImage image={this.props.image3} alt="Soporte VASCO Solutions" />
                </IconContainer>
                <Info>
                  <InfoTitle>
                    Abrir incidencia
                  </InfoTitle>
                  <InfoLinkContainer>
                    <Text>
                      Nuestro personal de Soporte estará encantado de poder ayudarte.
                    </Text>
                    <InfoLink target="_blank" href="https://vascosolutions.com/zc/supporttickets.php">
                      Abrir Ticket
                    </InfoLink>
                  </InfoLinkContainer>
                </Info>
              </InfoPart>

            </IconCol>
          </IconRow>
        </Container>
      </Section>
    )
  }

}

const Iconos = (props) => (
  <StaticQuery
    query={graphql`
      {          
        image1: file(relativePath: { eq: "icons/email2.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image2: file(relativePath: { eq: "icons/question.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image3: file(relativePath: { eq: "icons/tools.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }          
      }
    `}
    render={(data) => {
      const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
      const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
      const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
      return <ContactCreative data={data} image1={image1} image2={image2} image3={image3}{...props} />;
    }}
  />
);

export default Iconos;
